import React from 'react';

const QuestionProb = ({active_probability, changeActiveProbability, formatters}) => {

  const probabilities_display = ['Low','Medium','High'];
  const probabilities_value = [0.25, 0.5, 0.75];

  const handleClick = (value) => {
    changeActiveProbability(value);
  }

  return (
    <div className="border-bottom">
      <div className="py1 px2"
        style={{
          paddingBottom: '0.25rem',
          paddingTop: '0.25rem'
        }}
      >
        How much money would I need to have a
      </div>
      <div className="flex h5">
        {probabilities_display.map((word,i) =>
          <div
            key={i}
            className={"QuestionProbItem col-4 py1 pointer bg-light-gray center hover " + (probabilities_value[i] === active_probability ? "active" : "")}
            style={{
              padding: '0.525rem 0'
            }}
            onClick={handleClick.bind(this, probabilities_value[i])}
          >
            <div>{word} <span className="gray h6">({formatters.percentFormat(probabilities_value[i])})</span></div>
          </div>
        )}
      </div>
      <div className="py1 px2"
        style={{
          paddingTop: '0.25rem',
          paddingBottom: '0.45rem'
        }}
      >
        probability of being able to afford a property?
      </div>
    </div>
  )
}

export default QuestionProb;


/** WEBPACK FOOTER **
 ** ./src/components/QuestionProb.js
 **/